<template>
  <div :class="`lily-${contents.style}`">
    <div class="row">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12 banner text-center"
               @click="collapse = !collapse" role="button">
            <div class="banner-img">
              <img class="img-responsive"
                   :src="require(`@/assets/img/${contents.path}/banner.jpg`)"/>
            </div>
          </div>
        </div>
        <collapse v-model="collapse">
          <div v-if="contents.texts" class="intro text-center">
            <p v-for="(c, i) in contents.texts" :key="`text-${i}`"
               v-html="c">
            </p>
          </div>
          <div class="row alt">
            <div class="col-xs-12">
              <card-fill class="card" :list="cards" :card-style="contents.style"></card-fill>
            </div>
          </div>

          <div v-if="contents.videos">
            <slot name="video">
              <div class="col-xs-12">
                <div class="intro text-center">
                  <p>
                    Si votre établissement le permet, vous pouvez également
                    diffuser
                    <span v-if="contents.videos.length === 1">
                      la vidéo proposée
                    </span>
                    <span v-else>
                      les vidéos proposées
                    </span>
                    ci-dessous.
                  </p>
                </div>
              </div>
              <div class="row"
                   v-for="(v, k) in contents.videos" :key="`video-${k}`">
                <div class="col-xs-12 col-md-10 col-lg-8 col-md-offset-1 col-lg-offset-2">
                  <h3 v-if="v.title"
                      class="text-center"
                      :class="`txt-dark-${contents.style}`"
                      v-html="v.title">
                  </h3>
                  <p>
                    <video-frame width="100%" :link="v.url">
                    </video-frame>
                  </p>
                  <div class="text-center">
                    <p>
                      <a target="_blank"
                         class="btn btn-lg btn-dl"
                         :class="`btn-${contents.style}`"
                         :href="v.dl">
                        Télécharger le film
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </slot>
          </div>
        </collapse>
      </div>
    </div>
  </div>
</template>
<script>
import cardFill from '@/components/cards/cardFill'
import videoFrame from '@/components/videoFrame'

export default {
  name: 'lily',

  props: {
    contents: {
      type: Object,
      required: true
    },

    open: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      collapse: this.open
    }
  },

  computed: {
    cards: function () {
      const result = []
      const contents = this.contents
      const ratio = contents.cardsRatio
      for (let k in contents.cards) {
        const ref = contents.cards[k]
        result.push(
          {
            src: `${contents.path}/${k}.jpg`,
            type: ref.type,
            action: ref.action,
            text: ref.text,
            link: ref.link,
            ratio: ratio
          }
        )
      }

      return result
    }
  },

  components: {
    'video-frame': videoFrame,
    'card-fill': cardFill
  }

}
</script>
<style lang="less" scoped>
@import '~lily';

.lily-video {
  width: 100%;
  height: 100%;
}

.title {
  border-radius: 1rem;
  overflow: hidden;
}

.intro {
  font-size: 110%;
  margin-top: 4rem;
  margin-bottom: 4rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

.video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.video-container {
  position: relative;
  width: 100%;
  margin-bottom: 4rem;
}

.widescreen {
  padding-bottom: 56.25%; /* 9/16 = 0.5625 */
}

.banner {
  overflow: hidden;
}

.banner {
  .banner-img {
    width: 100%;
    height: 100%;
  }

  .banner-img::after {
    content: '\A';
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    opacity:  0;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
  }
}

.banner:hover {
  .banner-img::after {
    opacity: 1;
  }
}

.alt {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.btn-dl {
  margin-bottom: 3rem;
}

</style>
